import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { AdProviders, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
const MobileGridDynamic300x250 = /*#__PURE__*/ React.memo(({ safety = 'off', rowId, safetyState })=>{
    const _useAdUnit = useAdUnit(AdProviders.Freestar, `${ADUNIT_MAP['MobileGridDynamic300x250Gam']}-${rowId}`, safety, safetyState, {
        targeting: {
            unitType: 'btf'
        }
    }), { advertIsOff } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff === 'off') {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", slotAttr);
}, (last, next)=>{
    return last.safety === next.safety && last.rowId === next.rowId;
});
MobileGridDynamic300x250.displayName = 'MobileGridDynamic300x250';
export default MobileGridDynamic300x250;
